"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../Header.css");

var _reactOlext_logo = _interopRequireDefault(require("../../../../assets/images/react-olext_logo.svg"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Logo to be shown in the <i>Header</i> component: 
 * this component will be used as a child of
 * <i>Header</i> component.
 * @visibleName Header.Logo
 */
var Logo = function Logo(_ref) {
  var _ref$logo = _ref.logo,
      logo = _ref$logo === void 0 ? _reactOlext_logo.default : _ref$logo,
      style = _ref.style,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'logo' : _ref$alt,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? undefined : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? undefined : _ref$height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "rolext-header-logo",
    style: style,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
      src: logo,
      alt: alt,
      width: width,
      height: height
    })
  });
};

Logo.propTypes = {
  /**
   * A CSS Style to render the Logo
   */
  style: _propTypes.default.object,

  /**
   * The logo to be shown in the Header.
   * The default is the React-Olext Logo in
   * SVG format.
   */
  logo: _propTypes.default.any,

  /**
   * Specifies an alternate text for an image, if the image cannot be displayed
   */
  alt: _propTypes.default.string,

  /**
   * The height of the Logo.
   */
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * The width of the Logo.
   */
  width: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
var _default = Logo;
exports.default = _default;